import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Form, Input, Row, Col } from "antd";
import emailjs from "emailjs-com";

import Think from "../../assests/images/thinking-png-31407.png";
import { UserOutlined, MailOutlined, PhoneOutlined } from "@ant-design/icons";
import Sliders from "../../components/sliders";
import { BaseCard } from "../../components/base-card";
import Heading from "../../components/heading";
import logo1 from "../../assests/images/Kotak_Life.png";
import logo2 from "../../assests/images/Aditya Birla Capital Ltd Logo Download - SVG - All Vector Logo.jpeg";
import logo3 from "../../assests/images/Max_Life_Insurance_logo.svg";
import logo4 from "../../assests/images/Jana_Bank_Master_logo.jpg";
import logo5 from "../../assests/images/motilal.png";
import { ReactComponent as Item } from "../../assests/images/man-working-on-laptop.svg";

import styles from "./home.module.scss";

const HomePage = () => {
  const [form] = Form.useForm();
  const[loading,setLoading]=useState(false);
  const navigate = useNavigate();
  const sliderData = [
    {
      title: "Our Clients",
      content: (
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <img
            src={logo1}
            alt="Client 1"
            style={{ width: "30%", marginRight: "10px", height: "100px",marginLeft:"10px" }}
          />
          <img
            src={logo2}
            alt="Client 2"
            style={{ width: "30%", marginRight: "10px", height: "100px" }}
          />
          <img
            src={logo3}
            alt="Client 3"
            style={{ width: "30%", marginRight: "10px", height: "100px" }}
          />
        </div>
      ),
    },
    {
      title: "Our Clients",
      content: (
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <img
            src={logo4}
            alt="Client 1"
            style={{ width: "30%", marginRight: "10px", height: "100px" }}
          />
          <img
            src={logo5}
            alt="Client 2"
            style={{ width: "30%", marginRight: "10px", height: "100px" }}
          />
          <img
            src={logo3}
            alt="Client 3"
            style={{ width: "30%", marginRight: "10px", height: "100px" }}
          />
        </div>
      ),
    },
    {
      title: "Our Clients",
      content: (
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <img
            src={logo4}
            alt="Client 1"
            style={{ width: "30%", marginRight: "10px", height: "100px" }}
          />
          <img
            src={logo5}
            alt="Client 2"
            style={{ width: "30%", marginRight: "10px", height: "100px" }}
          />
          <img
            src={logo3}
            alt="Client 3"
            style={{ width: "30%", marginRight: "10px", height: "100px" }}
          />
        </div>
      ),
    },
  ];
  const onFinish = (values: any) => {
    setLoading(true);
    const serviceId = process.env.REACT_APP_EMAILJS_SERVICE_ID || "";
    const templateId = process.env.REACT_APP_EMAILJS_TEMPLATE_ID || "";
    const userId = process.env.REACT_APP_EMAILJS_USER_ID || "";

    const templateParams = {
      name: values.name,
      email: values.email,
      contact: values.contact,
      address: values.address,
      message: values.message,
    };

    emailjs.send(serviceId, templateId, templateParams, userId).then(
      (response) => {
        console.log("Email sent successfully", response);
        alert("Your enquiry has been sent successfully!");
        form.resetFields();
        setLoading(false);
      },
      (error) => {
        console.error("Email sending error", error);
        alert("Failed to send email. Please try again later.");
      }
    );
  };
  const onClick = () => {
    console.log("Button Clicked");
    navigate("/contact");
  };
  return (
    <>
      <Row className={styles["wrapper"]}>
        <Col span={12} xs={24} sm={24} md={12} xl={12} xxl={12}>
          <Heading
            heading="Welcome to Shivant HR Consultancy"
            subheading="We are a leading company in providing excellent services..."
          />
        </Col>
        <Col span={12} xs={24} sm={24} md={12} xl={12} xxl={12}>
          <BaseCard wrapperClassName={styles["form-wrapper"]}>
            <Heading
              heading="Enquiry Form"
              subheading="Please fill the form below to get in touch with us"
              subheadingClassname={styles["form-head"]}
              headingClassname={styles["form-subhead"]}
            />
            <Form layout="vertical" form={form} onFinish={onFinish}>
              <Form.Item label="Name" name="name" required
               rules={[
                {
                    required: true,
                    message: "Please fill in your name!",
                },
            ]}
              >
                <Input placeholder="Enter Name" prefix={<UserOutlined />} />
              </Form.Item>
              <Form.Item label="Mail" name="email"  rules={[
                {
                    required: true,
                    message: "Please fill in your email!",
                },
            ]}>
                <Input placeholder="Enter Email" prefix={<MailOutlined />} />
              </Form.Item>
              <Form.Item label="Contact" name="contact"  rules={[
                {
                    required: true,
                    message: "Please fill in your contact!",
                },
            ]}>
                <Input
                  placeholder="Enter Contact Number"
                  prefix={<PhoneOutlined />}
                />
              </Form.Item>
              <Form.Item label="Message" name="message" 
               rules={[
                {
                    required: true,
                    message: "Please select source!",
                },
            ]}>
                <Input.TextArea placeholder="Enter Message" />
              </Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                loading={loading}
              >
                Submit
              </Button>
            </Form>
          </BaseCard>
        </Col>
      </Row>
      <Row>
        <Col span={12} xs={24} sm={24} md={12} xl={12} xxl={12}>
          <img
            src={Think}
            alt="think"
            width={200}
            height={200}
            className={styles["think-icon"]}
          />
        </Col>

        <Col span={12} xs={24} sm={24} md={12} xl={12} xxl={12}>
          <p style={{ color: "#23a9ff", fontSize: 36, fontWeight: 800 }}>
            What is your destination ?
          </p>
          <p style={{ color: "#23a9ff", fontSize: 18, fontWeight: 600 }}>
            We are like your guide to take you to your destination. For that
            just choose who you are ?
          </p>
          <Row gutter={32}>
            <Col
            //    span={12}
            >
              <Button
                type="primary"
                //   style={{ width: "40%", height: "40px" }}
                onClick={onClick}
              >
                Job Seeker
              </Button>
            </Col>
            <Col
            // span={12}
            >
              <Button
                type="primary"
                onClick={onClick}
              >
                Employer
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
      <div>
        <div className={styles["dashed-line"]} />
        <Heading
          heading="Exclusive Services"
          subheading="We offer a wide range of services to our clients"
          headingClassname={styles["heading"]}
          subheadingClassname={styles["heading"]}
        />
        <div className={styles["exclusive-services"]}>
          {/* Center Image (Item) */}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
            }}
          >
            <Item width={200} height={200} className={styles["center-icon"]} />
          </div>

          {/* <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "100%",
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div
            className={styles["card1"]}
            >
              <BaseCard
                title="Leadership Hiring"
                wrapperClassName={styles["card-wrapper"]}
              />
            </div>
            <div
            className={styles["card2"]}
            >
              <BaseCard
                title="Permanent Staffing"
                wrapperClassName={styles["card-wrapper"]}
              />
            </div>
            <div
            className={styles["card3"]}
            >
              <BaseCard
                title="Contract Staffing"
                wrapperClassName={styles["card-wrapper"]}
              />
            </div>
            <div
            className={styles["card4"]}
            >
              <BaseCard
                title="Specialist Hiring"
                wrapperClassName={styles["card-wrapper"]}
              />
            </div>
            <div
            className={styles["card5"]}
            >
              <BaseCard
                title="Pay-Roll Processing"
                wrapperClassName={styles["card-wrapper"]}
              />
            </div>
          </div> */}
          <div className={styles["card-container"]}>
            <div className={styles["card1"]}>
              <BaseCard
                title="Leadership Hiring"
                wrapperClassName={styles["card-wrapper"]}
              />
            </div>
            <div className={styles["card2"]}>
              <BaseCard
                title="Permanent Staffing"
                wrapperClassName={styles["card-wrapper"]}
                // titleStyle={{color:"white"}}
              />
            </div>
            <div className={styles["card3"]}>
              <BaseCard
                title="Contract Staffing"
                wrapperClassName={styles["card-wrapper"]}
              />
            </div>
            <div className={styles["card4"]}>
              <BaseCard
                title="Specialist Hiring"
                wrapperClassName={styles["card-wrapper"]}
              />
            </div>
            <div className={styles["card5"]}>
              <BaseCard
                title="Pay-Roll Processing"
                wrapperClassName={styles["card-wrapper"]}
              />
            </div>
          </div>
        </div>
      </div>
      <div className={styles["dotted-line"]} />
      <Sliders data={sliderData} />
    </>
  );
};

export default HomePage;
